// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion'; // For animations

// const StartInspection = () => {
//   const [date, setDate] = useState('');
//   const [shift, setShift] = useState('');
//   const [supplier, setSupplier] = useState('');
//   const [suppliers, setSuppliers] = useState([]);
//   const [uploadFile, setUploadFile] = useState(null);
//   const [selectedSupplier, setSelectedSupplier] = useState('');
//   const [supplierShifts, setSupplierShifts] = useState([]);
//   const navigate = useNavigate();
//   const baseURL = process.env.REACT_APP_API_BASE_URL;

//   useEffect(() => {
//     const fetchSuppliers = async () => {
//       try {
//         const selectedProject = localStorage.getItem('selectedProject');
//         const response = await apiClient.post(`get_supplier_names`, {
//           projectId: selectedProject,
//         });
//         const supplierData = response.data.map(supplier => ({
//           name: supplier.name,
//           shift: supplier.shift,
//         }));
//         setSuppliers(supplierData);
//       } catch (error) {
//         console.error('Error fetching suppliers:', error);
//       }
//     };
//     fetchSuppliers();
//   }, []);

//   const handleStartInspection = async () => {
//     const selectedProjectId = localStorage.getItem('selectedProject');
//     if (!selectedProjectId) {
//       alert('Please select the project first.');
//       return;
//     }
//     if (!date || !shift || !supplier) {
//       alert('Please select date, shift, and supplier.');
//       return;
//     }

//     try {
//       ['stringerMainFormData', 'preLaminationFormData', 'postLaminationFormData', 'formData', 'DailyVolumeF4formData', 'PeelStrengthF6formData', 'CellToRibbonPeelStrengthF7formData', 'LaminationMachineF8formData', 'calibrationVerificationF9formData', 'FlashTestWitnessF10formData', 'PrimaryModuleCalibrationF11formData', 'FrameSealantWeightF12formData', 'JunctionBoxSealantWeightVerificationF13formData', 'JunctionBoxPottingF14formData', 'ModuleDimensionCheckF15formData', 'RecordRejectedModuleF16formData', 'RFIDReadabilityF17formData', 'MachineBreakdownF18formData', 'RootCauseAnalysisF19formData', 'inspectionData'].forEach(item => {
//         sessionStorage.removeItem(item);
//       });
//       const response = await apiClient.post(`get_meta_data`, {
//         projectId: selectedProjectId,
//         supplierName: supplier
//       });

//       sessionStorage.setItem('metadata', JSON.stringify(response.data));
//       sessionStorage.setItem('inspectionDate', date);
//       sessionStorage.setItem('inspectionShift', shift);
//       sessionStorage.setItem('inspectionSupplier', supplier);

//       navigate('/inspections/forms');
//     } catch (error) {
//       console.error('Error starting inspection:', error);
//       alert('Failed to start inspection.');
//     }
//   };

//   const handleViewInspection = () => {
//     const selectedProjectId = localStorage.getItem('selectedProject');
//     if (!selectedProjectId) {
//       alert('Please select the project first.');
//       return;
//     }
//     if (!date || !shift || !supplier) {
//       alert('Please select date, shift, and supplier.');
//       return;
//     }

//     sessionStorage.setItem('inspectionDate', date);
//     sessionStorage.setItem('inspectionShift', shift);
//     sessionStorage.setItem('inspectionSupplier', supplier);

//     navigate('/view-inspection');
//   };

//   const handleFileChange = (e) => {
//     setUploadFile(e.target.files[0]);
//   };

//   const handleSupplierChange = (e) => {
//     const selectedSupplierName = e.target.value;
//     setSupplier(selectedSupplierName);

//     const selectedSupplierData = suppliers.find(sup => sup.name === selectedSupplierName);
//     if (selectedSupplierData) {
//       const shiftOptions =
//         selectedSupplierData.shift === "MorningAfternoonNight"
//           ? ["Morning", "Afternoon", "Night"]
//           : ["Day", "Night"];
//       setSupplierShifts(shiftOptions);
//     } else {
//       setSupplierShifts([]);
//     }
//   };

//   const handleSubmit = async () => {
//     const selectedProjectId = localStorage.getItem('selectedProject');
//     if (!selectedProjectId) {
//       alert('Please select the project first.');
//       return;
//     }

//     if (!selectedSupplier || !uploadFile) {
//       alert('Please select a supplier and upload a file.');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('projectId', selectedProjectId);
//     formData.append('supplierName', selectedSupplier);
//     formData.append('file', uploadFile);

//     try {
//       await axios.post(
//         `${baseURL}upload_meta_data`,
//         formData,
//         { headers: { 'Content-Type': 'multipart/form-data' } }
//       );
//       alert('File uploaded successfully!');
//     } catch (error) {
//       if (error.response && error.response.data && error.response.data.error) {
//         const errorMessage = error.response.data.error;
//         if (errorMessage.includes("Sheet 'Sheet1' is missing required columns")) {
//           alert(`Error: ${errorMessage}`);
//         } else {
//           alert(`Failed to upload file: ${errorMessage}`);
//         }
//       } else {
//         alert('An unexpected error occurred during file upload. Please try again.');
//       }
//     }
//   };

//   return (
//     <div className="flex items-center justify-center p-4 md:p-8 rounded-md">
//       <div className="container max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
//         {/* Start Inspection Card */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.5 }}
//           className="bg-white rounded-2xl shadow-xl p-8 flex flex-col"
//         >
//           <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-6">Start Inspection</h1>
          
//           {/* Date Input */}
//           <div className="mb-5">
//             <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-2">Inspection Date</label>
//             <input
//               type="date"
//               id="date"
//               value={date}
//               onChange={(e) => setDate(e.target.value)}
//               max={new Date().toISOString().split("T")[0]}
//               className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-all duration-200 bg-gray-50 text-gray-800"
//             />
//           </div>

//           {/* Supplier Dropdown */}
//           <div className="mb-5">
//             <label htmlFor="supplier" className="block text-sm font-medium text-gray-700 mb-2">Select Supplier</label>
//             <select
//               id="supplier"
//               value={supplier}
//               onChange={handleSupplierChange}
//               className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-all duration-200 bg-gray-50 text-gray-800"
//             >
//               <option value="">Select Supplier</option>
//               {suppliers.map((supplier, index) => (
//                 <option key={index} value={supplier.name}>
//                   {supplier.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Shift Dropdown */}
//           <div className="mb-5">
//             <label htmlFor="shift" className="block text-sm font-medium text-gray-700 mb-2">Select Shift</label>
//             <select
//               id="shift"
//               value={shift}
//               onChange={(e) => setShift(e.target.value)}
//               className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-all duration-200 bg-gray-50 text-gray-800"
//             >
//               <option value="">Select Shift</option>
//               {supplierShifts.map((shiftOption, index) => (
//                 <option key={index} value={shiftOption}>
//                   {shiftOption}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Buttons */}
//           <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
//             <motion.button
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={handleStartInspection}
//               className="w-full sm:w-auto px-6 py-3 bg-gray-600 text-white rounded-lg font-semibold shadow-md hover:bg-gray-700 focus:ring-4 focus:ring-gray-300 transition-all duration-200"
//             >
//               Start Inspection
//             </motion.button>
//             <motion.button
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={handleViewInspection}
//               className="w-full sm:w-auto px-6 py-3 bg-gray-600 text-white rounded-lg font-semibold shadow-md hover:bg-gray-700 focus:ring-4 focus:ring-gray-300 transition-all duration-200"
//             >
//               View Inspection
//             </motion.button>
//           </div>
//         </motion.div>

//         {/* Upload Supplier Metadata Card */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.5, delay: 0.2 }}
//           className="bg-white rounded-2xl shadow-xl p-8 flex flex-col"
//         >
//           <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-6">Upload Supplier Metadata</h1>

//           {/* Supplier Dropdown */}
//           <div className="mb-5">
//             <label htmlFor="selectedSupplier" className="block text-sm font-medium text-gray-700 mb-2">Select Supplier</label>
//             <select
//               id="selectedSupplier"
//               value={selectedSupplier}
//               onChange={(e) => setSelectedSupplier(e.target.value)}
//               className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-all duration-200 bg-gray-50 text-gray-800"
//             >
//               <option value="">Select Supplier</option>
//               {suppliers.map((supplier, index) => (
//                 <option key={index} value={supplier.name}>
//                   {supplier.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* File Upload */}
//           <div className="mb-5">
//             <label htmlFor="fileUpload" className="block text-sm font-medium text-gray-700 mb-2">Upload File</label>
//             <div className="relative">
//               <input
//                 type="file"
//                 id="fileUpload"
//                 onChange={handleFileChange}
//                 className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-all duration-200 bg-gray-50 text-gray-800 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200"
//               />
//               {uploadFile && (
//                 <motion.p
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   className="mt-2 text-sm text-gray-600"
//                 >
//                   Selected: {uploadFile.name}
//                 </motion.p>
//               )}
//             </div>
//           </div>

//           {/* Submit Button */}
//           <motion.div
//             className="mt-6 flex justify-center"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.4 }}
//           >
//             <motion.button
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={handleSubmit}
//               className="w-full sm:w-auto px-8 py-3 bg-gray-600 text-white rounded-lg font-semibold shadow-md hover:bg-gray-700 focus:ring-4 focus:ring-gray-300 transition-all duration-200"
//             >
//               Submit
//             </motion.button>
//           </motion.div>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default StartInspection;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import apiClient from '../../pages/keycloak/axiosInstance';

const StartInspection = () => {
  const [date, setDate] = useState('');
  const [shift, setShift] = useState('');
  const [supplier, setSupplier] = useState('');
  const [suppliers, setSuppliers] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState('');
  const [supplierShifts, setSupplierShifts] = useState([]);
  
  // Role checks
  const [canEditMetadata, setCanEditMetadata] = useState(false);
  const [canStartInspection, setCanStartInspection] = useState(false);

  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  // Check roles from sessionStorage
  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (storedRoles) {
      let roles = [];
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
      setCanEditMetadata(roles.includes("Inspections_Metadata_Edit"));
      setCanStartInspection(roles.includes("Inspections_Edit"));
    }
  }, []);

  // Fetch suppliers from backend
  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const selectedProject = localStorage.getItem('selectedProject');
        const response = await apiClient.post(`get_supplier_names`, {
          projectId: selectedProject,
        });
        const supplierData = response.data.map(supplier => ({
          name: supplier.name,
          shift: supplier.shift,
        }));
        setSuppliers(supplierData);
      } catch (error) {
        console.error('Error fetching suppliers:', error);
      }
    };
    fetchSuppliers();
  }, []);

  // Filter suppliers: only show those user has role projectId_supplierName_view
  const projectId = localStorage.getItem('selectedProject');

  const allowedSuppliers = suppliers.filter(supplier => {
    if (!projectId) return false;
    const userRoles = JSON.parse(sessionStorage.getItem("userRoles") || "[]");
    const requiredRole = `${projectId}_${supplier.name}_view`;
    return userRoles.includes(requiredRole);
  });

  const handleStartInspection = async () => {
    const selectedProject = localStorage.getItem('selectedProject');
    if (!selectedProject) {
      alert('Please select the project first.');
      return;
    }
    if (!date || !shift || !supplier) {
      alert('Please select date, shift, and supplier.');
      return;
    }

    try {
      ['stringerMainFormData', 'preLaminationFormData', 'postLaminationFormData', 'formData', 'DailyVolumeF4formData', 'PeelStrengthF6formData', 'CellToRibbonPeelStrengthF7formData', 'LaminationMachineF8formData', 'calibrationVerificationF9formData', 'FlashTestWitnessF10formData', 'PrimaryModuleCalibrationF11formData', 'FrameSealantWeightF12formData', 'JunctionBoxSealantWeightVerificationF13formData', 'JunctionBoxPottingF14formData', 'ModuleDimensionCheckF15formData', 'RecordRejectedModuleF16formData', 'RFIDReadabilityF17formData', 'MachineBreakdownF18formData', 'RootCauseAnalysisF19formData', 'inspectionData'].forEach(item => {
        sessionStorage.removeItem(item);
      });

      const response = await apiClient.post(`get_meta_data`, {
        projectId: selectedProject,
        supplierName: supplier
      });

      sessionStorage.setItem('metadata', JSON.stringify(response.data));
      sessionStorage.setItem('inspectionDate', date);
      sessionStorage.setItem('inspectionShift', shift);
      sessionStorage.setItem('inspectionSupplier', supplier);

      navigate('/inspections/forms');
    } catch (error) {
      console.error('Error starting inspection:', error);
      alert('Failed to start inspection.');
    }
  };

  const handleViewInspection = () => {
    const selectedProject = localStorage.getItem('selectedProject');
    if (!selectedProject) {
      alert('Please select the project first.');
      return;
    }
    if (!date || !shift || !supplier) {
      alert('Please select date, shift, and supplier.');
      return;
    }

    sessionStorage.setItem('inspectionDate', date);
    sessionStorage.setItem('inspectionShift', shift);
    sessionStorage.setItem('inspectionSupplier', supplier);

    navigate('/view-inspection');
  };

  const handleFileChange = (e) => {
    setUploadFile(e.target.files[0]);
  };

  const handleSupplierChange = (e) => {
    const selectedSupplierName = e.target.value;
    setSupplier(selectedSupplierName);

    const selectedSupplierData = suppliers.find(sup => sup.name === selectedSupplierName);
    if (selectedSupplierData) {
      const shiftOptions =
        selectedSupplierData.shift === "MorningAfternoonNight"
          ? ["Morning", "Afternoon", "Night"]
          : ["Day", "Night"];
      setSupplierShifts(shiftOptions);
    } else {
      setSupplierShifts([]);
    }
  };

  const handleSubmit = async () => {
    const selectedProjectId = localStorage.getItem('selectedProject');
    if (!selectedProjectId) {
      alert('Please select the project first.');
      return;
    }

    if (!selectedSupplier || !uploadFile) {
      alert('Please select a supplier and upload a file.');
      return;
    }

    const formData = new FormData();
    formData.append('projectId', selectedProjectId);
    formData.append('supplierName', selectedSupplier);
    formData.append('file', uploadFile);

    try {
      await apiClient.post(
        `upload_meta_data`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      alert('File uploaded successfully!');
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        if (errorMessage.includes("Sheet 'Sheet1' is missing required columns")) {
          alert(`Error: ${errorMessage}`);
        } else {
          alert(`Failed to upload file: ${errorMessage}`);
        }
      } else {
        alert('An unexpected error occurred during file upload. Please try again.');
      }
    }
  };

  return (
    <div className="flex items-center justify-center p-4 md:p-8 rounded-md">
      <div className={`container max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8`}>
        {/* Start Inspection Card */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white rounded-2xl shadow-xl p-8 flex flex-col"
        >
          <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-6">Start Inspection</h1>
          
          <div className="mb-5">
            <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-2">Inspection Date</label>
            <input
              type="date"
              id="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              max={new Date().toISOString().split("T")[0]}
              className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-all duration-200 bg-gray-50 text-gray-800"
            />
          </div>

          {/* Filtered Supplier Dropdown */}
          <div className="mb-5">
            <label htmlFor="supplier" className="block text-sm font-medium text-gray-700 mb-2">Select Supplier</label>
            <select
              id="supplier"
              value={supplier}
              onChange={handleSupplierChange}
              className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-all duration-200 bg-gray-50 text-gray-800"
            >
              <option value="">Select Supplier</option>
              {allowedSuppliers.map((supplier, index) => (
                <option key={index} value={supplier.name}>
                  {supplier.name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-5">
            <label htmlFor="shift" className="block text-sm font-medium text-gray-700 mb-2">Select Shift</label>
            <select
              id="shift"
              value={shift}
              onChange={(e) => setShift(e.target.value)}
              className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-all duration-200 bg-gray-50 text-gray-800"
            >
              <option value="">Select Shift</option>
              {supplierShifts.map((shiftOption, index) => (
                <option key={index} value={shiftOption}>
                  {shiftOption}
                </option>
              ))}
            </select>
          </div>

          <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
            {canStartInspection && (
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleStartInspection}
                className="w-full sm:w-auto px-6 py-3 bg-gray-600 text-white rounded-lg font-semibold shadow-md hover:bg-gray-700 focus:ring-4 focus:ring-gray-300 transition-all duration-200"
              >
                Start Inspection
              </motion.button>
            )}

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleViewInspection}
              className="w-full sm:w-auto px-6 py-3 bg-gray-600 text-white rounded-lg font-semibold shadow-md hover:bg-gray-700 focus:ring-4 focus:ring-gray-300 transition-all duration-200"
            >
              View Inspection
            </motion.button>
          </div>
        </motion.div>

        {/* Upload Supplier Metadata Card */}
        {canEditMetadata && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-white rounded-2xl shadow-xl p-8 flex flex-col"
          >
            <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-6">Upload Supplier Metadata</h1>

            {/* Filtered Supplier Dropdown */}
            <div className="mb-5">
              <label htmlFor="selectedSupplier" className="block text-sm font-medium text-gray-700 mb-2">Select Supplier</label>
              <select
                id="selectedSupplier"
                value={selectedSupplier}
                onChange={(e) => setSelectedSupplier(e.target.value)}
                className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-all duration-200 bg-gray-50 text-gray-800"
              >
                <option value="">Select Supplier</option>
                {allowedSuppliers.map((supplier, index) => (
                  <option key={index} value={supplier.name}>
                    {supplier.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-5">
              <label htmlFor="fileUpload" className="block text-sm font-medium text-gray-700 mb-2">Upload File</label>
              <div className="relative">
                <input
                  type="file"
                  id="fileUpload"
                  onChange={handleFileChange}
                  className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-all duration-200 bg-gray-50 text-gray-800 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200"
                />
                {uploadFile && (
                  <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="mt-2 text-sm text-gray-600"
                  >
                    Selected: {uploadFile.name}
                  </motion.p>
                )}
              </div>
            </div>

            <motion.div
              className="mt-6 flex justify-center"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleSubmit}
                className="w-full sm:w-auto px-8 py-3 bg-gray-600 text-white rounded-lg font-semibold shadow-md hover:bg-gray-700 focus:ring-4 focus:ring-gray-300 transition-all duration-200"
              >
                Submit
              </motion.button>
            </motion.div>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default StartInspection;